var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highcharts',{staticClass:"delta-chart",attrs:{"options":_vm.deltaChartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }